import { Route } from 'react-router-dom';

import { NAV_ROUTES } from '@constants/navRoutes';
import { ShareLayout } from '@layouts';
import { SUBMODULE_TYPE } from '@constants/constants';
import Share from '../pages/Share';

/**
 * ShareRoutes - Centralized route definitions for all shared dashboard types
 *
 * All routes follow the pattern: /{dashboard-type}/:inviteId
 * The Share component acts as a mapper to route to specific dashboard implementations
 *
 * Note: Suspense and loading states are handled by ShareLayout
 */

// Export Route fragments to be used in AppRoutes.tsx
const ShareRoutes = (
  <>
    {/* Investor Report Share */}
    <Route element={<ShareLayout />}>
      <Route
        path={NAV_ROUTES.SHARE_INVESTOR_REPORT}
        element={<Share type={SUBMODULE_TYPE.INVESTOR_REPORT_V2_EXT} />}
      />
    </Route>
  </>
);

export default ShareRoutes;
